import { render, staticRenderFns } from "./ShowStages.vue?vue&type=template&id=0523a066&scoped=true&"
import script from "./ShowStages.vue?vue&type=script&lang=js&"
export * from "./ShowStages.vue?vue&type=script&lang=js&"
import style0 from "./ShowStages.vue?vue&type=style&index=0&id=0523a066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523a066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardTitle,VDialog})
